import { useState } from 'react'
import { Button, EmptyState, Skeleton } from '@teach/ui'
import { CreditCard } from 'lucide-react'
import { useGetMyPaymentsQuery } from '@/features/ai/credits/paymentsApi'
import { HistoryPager } from '@/features/ai/credits/HistoryPager'
import { PaymentRow } from './PaymentRow'
import { PaymentsHeader } from './PaymentsHeader'
import { useMessages } from '@/i18n'
import { messages } from './messages'

const LIMIT = 20

/**
 * История ПЛАТЕЖЕЙ, а не движений: когда, какой пакет, на какую сумму и в
 * каком статусе. Неоплаченный и отклонённый заказы отсюда не убираются — иначе
 * «оплатил, не зачислилось» становится неразрешимым вопросом поддержки.
 */
export const PaymentsHistory = () => {
  const [page, setPage] = useState(1)
  const m = useMessages(messages)
  const { data, isLoading, isError, refetch } = useGetMyPaymentsQuery({ page, limit: LIMIT })

  if (isLoading)
    return (
      <div className="space-y-2">
        {[0, 1, 2].map((row) => (
          <Skeleton key={row} className="h-14 w-full" />
        ))}
      </div>
    )

  if (isError)
    return (
      <div className="space-y-2 rounded-xl border border-warning/30 bg-warning/10 p-3 text-xs">
        <p>{m.paymentsLoadFailed}</p>
        <Button variant="outline" size="sm" onClick={() => void refetch()}>
          {m.retry}
        </Button>
      </div>
    )

  if (!data || data.items.length === 0)
    return (
      <EmptyState
        icon={CreditCard}
        className="min-h-80"
        title={m.noPurchases}
        description={m.noPurchasesHint}
      />
    )

  return (
    <div>
      <PaymentsHeader />
      <div>
        {data.items.map((item) => (
          <PaymentRow key={item.id} item={item} />
        ))}
      </div>
      <HistoryPager page={data.page} pages={data.pages} onPageChange={setPage} />
    </div>
  )
}
